<template>
  <onboard-wrap>
    <template slot="content">
      <header>
        <h1 class="h3">All set! Your team is ready!</h1>
        <p>Invite your whole team to try TunnelBear free for 7 days. Enter their emails below.</p>
      </header>
      <invite-portal @inviteSuccess="inviteSuccess()" @typing="triggerTyping($event)"></invite-portal>
      <router-link class="skip" :to="{name: 'overview', hash: '#download'}">I'll do this later</router-link>
    </template>
    <template slot="extra">
      <div class="bear-wrap">
        <template v-if="imgsLoaded && is.not.mobile()">
          <img class="body" :src="imgSrcs.left[animationIndex.left].src" alt="">
          <img class="arm" :src="imgSrcs.right[animationIndex.right].src" alt="">
          <img class="head" :src="imgSrcs.head[animationIndex.head].src" alt="">
        </template>
        <img v-else src="./images/animation/full-bear.png" alt="">
      </div>
      <div class="text-center">
        <h2 class="h3">Standing by to send invites...</h2>
        <p>Our Bears are ready to add members to your team.</p>
      </div>
      <div v-if="domain" class="domain-signup">
        <img src="./images/email_bear@2x.png" alt="">
        <p><span class="tip">Tip:</span> Secure your team even faster with <strong>domain signup</strong>. When enabled, anyone
          with the <strong>{{'@' + domain}}</strong> email address will automatically
          join your team when they create a TunnelBear account.
        </p>
      </div>
    </template>
  </onboard-wrap>
</template>

<script>
import onboardWrap from '@/components/onboard-wrap/onboard-wrap'
import invitePortal from '@/components/invite-portal/invite-portal'
import is from 'is_js'
import services from '@/services/services.js'

export default {
  name: 'invite',
  components: {
    'onboard-wrap': onboardWrap,
    'invite-portal': invitePortal
  },
  data () {
    return {
      is: is,
      imgsLoaded: false,
      imgSrcs: {
        head: [{src: require('./images/animation/head7.png')}],
        left: [{src: require('./images/animation/body0.png')}],
        right: [{src: require('./images/animation/arm0.png')}]
      },
      animationIndex: {
        head: 7,
        left: 0,
        right: 0
      },
      headMoving: false,
      typing: false,
      typeRightArm: true
    }
  },
  created: function () {
    this.$store.dispatch('getUserData').then(() => {
      this.$store.dispatch('validateDomain')
    })

    if (is.not.mobile()) this.preloadImages()
  },
  computed: {
    domain: function () {
      return this.$store.getters.domain || ''
    }
  },
  mounted: function () {
    setTimeout(function () {
      if (this.imgsLoaded && is.not.mobile()) {
        this.animateHead('down')
      }
    }.bind(this), 1800)
  },
  methods: {
    inviteSuccess: function () {
      this.$router.push({name: 'overview', hash: '#download'})
    },
    triggerTyping: function (key) {
      if (!this.headMoving) {
        this.animateHead('down')
      }
      if (!this.typing) {
        this.typeRightArm = (key === 'Backspace') || !this.typeRightArm
        this.animateTyping(this.typeRightArm)
      }
    },
    animateHead: function (direction) {
      this.headMoving = true
      if (direction === 'down') {
        if (this.animationIndex.head < 1) {
          setTimeout(function () {
            this.animateHead('up')
          }.bind(this), 2000)
          return
        }
        this.animationIndex.head--
      } else if (direction === 'up') {
        if (this.animationIndex.head > 6) {
          this.headMoving = false
          return
        }
        this.animationIndex.head++
      }
      setTimeout(function () {
        this.animateHead(direction)
      }.bind(this), 60)
    },
    animateTyping: function (right) {
      let side = right ? 'right' : 'left'
      this.typing = true
      let maxIndex = 2
      this.animationIndex[side]++
      if (this.animationIndex[side] > maxIndex) this.animationIndex[side] = 0

      if (this.animationIndex[side] === 0) {
        this.typing = false
        return
      }
      setTimeout(function () {
        this.animateTyping(right)
      }.bind(this), 50)
    },
    preloadImages: function () {
      services.preloadImages([require('./images/animation/body0.png'), require('./images/animation/body1.png'), require('./images/animation/body2.png')]).then((response) => {
        this.imgSrcs.left = response
      })
      services.preloadImages([require('./images/animation/arm0.png'), require('./images/animation/arm1.png'), require('./images/animation/arm2.png')]).then((response) => {
        this.imgSrcs.right = response
      })
      services.preloadImages([require('./images/animation/head0.png'), require('./images/animation/head1.png'), require('./images/animation/head2.png'), require('./images/animation/head3.png'), require('./images/animation/head4.png'), require('./images/animation/head5.png'), require('./images/animation/head6.png'), require('./images/animation/head7.png')]).then((response) => {
        this.imgSrcs.head = response
        this.imgsLoaded = true
      })
    }
  }
}
</script>

<style scoped lang="stylus" src="./invite.styl" >



// WEBPACK FOOTER //
// src/views/onboarding/views/invite/invite.vue